(function() { module.exports = window["Bernie_l10nBundle_de_AT"]; }());